import {
  transactionColumns,
  useGetAllPoolTransactions,
  withUserColumn,
} from '@entities/transaction';
import {MrTable} from '@shared/components';
import {entityTableCommonProps} from '@shared/constants';
import {useUrlState} from '@shared/hooks';

import {PaginationState} from '@/shared/types';

const localStorageKey = 'allPoolTransactionsTable';

const columns = withUserColumn(transactionColumns);

export const AllPoolTransactionsTab = () => {
  const {urlState, setUrl} = useUrlState<PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });

  const {data, isFetching, error} = useGetAllPoolTransactions({
    page: urlState.pageIndex + 1,
    pageSize: urlState.pageSize,
  });

  return (
    <MrTable
      columns={columns}
      data={data?.items ?? []}
      error={error}
      enableColumnOrdering
      enableColumnDragging={false}
      localStorageKeyForSettings={localStorageKey}
      enableHiding
      /////////////////////////////
      // pagination + state
      enablePagination
      manualPagination
      onPaginationChange={updater =>
        setUrl(prev => ({
          ...prev,
          ...(typeof updater === 'function' ? updater(prev) : updater),
        }))
      }
      rowCount={data?.total ?? 0}
      /////////////////////////////
      state={{
        isLoading: isFetching,
        pagination: {
          pageIndex: urlState.pageIndex,
          pageSize: urlState.pageSize,
        },
      }}
      {...entityTableCommonProps}
      enableRowActions={false}
    />
  );
};
